'use client';

import { BackButton } from '@/components/design/registration/BackButton';
import { ForwardFlowButton } from '@/components/design/registration/ForwardFlowButton';

interface FlowStepNavigationProps {
  className?: string;
  backLabel?: string;
  forwardLabel?: string;
}

export function FlowStepNavigation({
  className = '',
  backLabel,
  forwardLabel,
}: FlowStepNavigationProps) {
  return (
    <div
      className={`flex min-w-0 w-full flex-wrap items-center justify-between gap-4 ${className}`}
    >
      <BackButton label={backLabel} />
      <ForwardFlowButton label={forwardLabel} />
    </div>
  );
}
